import React from 'react';
import ServiceCard from '../ServiceCard/ServiceCard';
import './ServiceList.scss';

import serviceImage1 from '../../images/laura-service-1.svg';
import serviceImage2 from '../../images/laura-service-2.svg';

const ServiceList = () => {
    const services = [
        {
            id: 1,
            image: serviceImage1,
            title: "Coach en éducation canine",
            description: "L’éducation canine, c’est apprendre à vivre en harmonie avec son chien. Elle aide à poser des bases simples et positives pour que le chien comprenne son environnement, tout en renforçant la confiance et la complicité avec son maître.",
            imageAlt: "Séance d'éducation canine avec Laura Perillo"
        },
        {
            id: 2,
            image: serviceImage2,
            title: "Comportementaliste canin",
            description: "Le comportementaliste canin accompagne les chiens qui rencontrent des difficultés émotionnelles ou comportementales. Il ne s’agit pas de “corriger” le chien, mais de comprendre l’origine de ses réactions et de l’aider, pas à pas, à retrouver équilibre, sérénité et confiance.",
            imageAlt: "Consultation comportementale pour chien avec Laura Perillo",
            reverse: true
        },
    ];

    return (
        <section className="service-list-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title text-center" style={{ paddingTop: '60px' }}>
                            <span>Mes Consultations</span>
                            <h2>Un accompagnement sur mesure pour vous et votre chien</h2>
                        </div>
                    </div>
                </div>
                <div className="service-list">
                    {services.map((service) => (
                        <ServiceCard
                            key={service.id}
                            image={service.image}
                            title={service.title}
                            description={service.description}
                            imageAlt={service.imageAlt}
                            reverse={service.reverse}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceList;